import * as React from 'react'
import { useMemo } from 'react'

import { IconWrapper } from './IconWrapper.styled'

import {
  AgreementIcon,
  PaymentIconV2,
  ScheduleIcon,
  ServiceIconV2,
} from '@sales-center/components'

export type IconProps = {
  icon: 'service' | 'agreement' | 'payment' | 'appointments'
}

export function Icon(props: IconProps) {
  const { icon } = props

  const iconComponent = useMemo(() => {
    switch (icon) {
      case 'agreement':
        return <AgreementIcon />
      case 'payment':
        return <PaymentIconV2 />
      case 'service':
        return <ServiceIconV2 />
      case 'appointments':
        return <ScheduleIcon />
    }
  }, [icon])

  return <IconWrapper>{iconComponent}</IconWrapper>
}
